const IconWarning = () => {
  return (
    <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_2)">
        <path
          d="M17.1428 0C18.0937 0 18.971 0.502232 19.4531 1.32589L33.9174 25.9687C34.4062 26.7991 34.4062 27.8237 33.9308 28.654C33.4553 29.4844 32.5647 30 31.6071 30H2.67854C1.72095 30 0.830327 29.4844 0.354881 28.654C-0.120566 27.8237 -0.11387 26.7924 0.368273 25.9687L14.8326 1.32589C15.3147 0.502232 16.1919 0 17.1428 0ZM17.1428 8.57143C16.2522 8.57143 15.5357 9.28795 15.5357 10.1786V17.6786C15.5357 18.5692 16.2522 19.2857 17.1428 19.2857C18.0335 19.2857 18.75 18.5692 18.75 17.6786V10.1786C18.75 9.28795 18.0335 8.57143 17.1428 8.57143ZM19.2857 23.5714C19.2857 22.3862 18.3281 21.4286 17.1428 21.4286C15.9576 21.4286 15 22.3862 15 23.5714C15 24.7567 15.9576 25.7143 17.1428 25.7143C18.3281 25.7143 19.2857 24.7567 19.2857 23.5714Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_2">
          <rect width="34.2857" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconWarning;
